export interface ITitleInfoProps {
  text: string;
  time: string;
}
/**
 * -----------------------------------------------------------------------------
 * It renders a title and the record time text
 */
export function TitleInfo({ text, time }: Readonly<ITitleInfoProps>) {
  return (
    <div className="flex flex-col items-start gap-x-3 sm:flex-row sm:items-center">
      <div className="text-sm font-medium text-gray-950">{text}</div>
      <div className="text-xs text-gray-400">{time}</div>
    </div>
  );
}
